import {inject, injectable} from 'inversify';

import type {BNFormApiModel} from '../../../../../api/types/bnrks/models';
import type {ChoiceQuestionModel} from '../ChoiceQuestion.model';

import {QuestionModel} from '../../Question.model';
import {ChoiceQuestionFactory} from '../ChoiceQuestion.factory';

type Question = BNFormApiModel['sections'][0]['questions'][0];

@injectable()
export class ChoiceQuestionMapperJrpc {
  constructor(
    @inject(ChoiceQuestionFactory)
    private readonly factory: ChoiceQuestionFactory,
  ) {}

  mapToModel(data: Question) {
    return this.factory.create({
      id: data.uuid,
      isRequired: !data.is_optional,
      options: this.options(data),
      title: data.question,
      type: this.type(data),
    });
  }

  options(data: Question): ChoiceQuestionModel['options'] {
    return Object.entries(data.options ?? {}).map(([id, option]) => ({
      id,
      score: option.score,
      title: option.title,
    }));
  }

  type(data: Question) {
    const types: {[key in Question['type']]?: QuestionModel.Type} = {
      multiple_choice: 'checkboxes',
      single_choice: 'multiple_choice',
    };

    const type = types[data.type];

    if (!type) {
      throw new Error(`Unknown question type: ${data.type}`);
    }

    return type;
  }
}
